// import { showIndex } from "../include/module";
// import { anchorLink } from "../include/module";
//
//
// (() => {
//
//   showIndex();
//   anchorLink();
//
// })();
var windowW       = $(window).width();
var windowH       = $(window).innerHeight();

//preload
import {preload} from "../include/module";
preload();


$(window).on('load' , function() {
  showIndex();

});


function showIndex() {
  setTimeout(function(){
    $("#st-Container").addClass("fixed");
    var scrollPo = $("#detail_0").offset().top;
    $("#st-Container").css({"top":-scrollPo + 80});
  },100);

  setTimeout(function(){$('#anime_Bg').removeClass("hidden");},150);
  setTimeout(function(){
    $("#st-Container").stop().animate({"top":0},2200,'easeInOutQuart',function(){
    $("#st-Container").removeClass("fixed");
    // $("#st-Container"").css({"top":0});
    });
    $('#visual-img').addClass("changed");
    $('#top-logo').addClass("changed");
  },800);
  setTimeout(function(){$('#anime_Ttl').removeClass("hidden");},2600);
  setTimeout(function(){$('#anime_Txt').removeClass("hidden");},3200);
  setTimeout(function(){showItem();},3200);
};

/*******************************************************

showItem

********************************************************/
const showItem = () => {
  var targetPositionAdd;

  targetPositionAdd = 100;
  if(windowW >= 1024){
      targetPositionAdd = 100;
  }else{
    targetPositionAdd = 60;
  }

  var scrollPosition = $(window).scrollTop();

  $(window).on("load resize", function () {
    windowW       = $(window).width();
    windowH       = $(window).innerHeight();
  });

  //ファーストビュー内にあるアイテム
  $('.anim_Item').each(function(){
    var targetPosition = $(this).offset().top;
    if(targetPosition < (windowH + scrollPosition)){
      $(this).addClass("show");
    }
  });

  //ファーストビューより下にあるアイテム（スクロールで表示）
  $(window).on('scroll',function(){
    scrollPosition = $(window).scrollTop();
    $('.anim_Item').each(function(){
      var targetPosition = $(this).offset().top;
      if(scrollPosition > targetPosition - windowH + targetPositionAdd){
        $(this).addClass("show");
      }
    });

  });
};



// WEBPACK FOOTER //
// ./src/roselia-movie_v0/assets/js/teaser/script.js